// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"3cc4c168","302":"1251a954","324":"c8c6f4d1","450":"f2a937af","530":"f4425ba7","536":"9756bb46","641":"8c1d4658","998":"7b53bdc3"}[chunkId] + ".chunk.css";
};